import { gettext } from '@eventbrite/i18n';
import React from 'react';

import styles from './Common.module.scss';

export const TBDEventLocation = () => (
    <div>
        <p className={styles.locationText}>{gettext('To be announced')}</p>
    </div>
);
